import { Channel, Socket } from 'phoenix';

// to keep track of online users from backoffice
export const joinOnlineUsersChannel = (userToken: string, path: string) => {
  const host =
    location.hostname === 'expert360.local'
      ? '/socket'
      : `//ws.${location.hostname.replace('app.', '')}/socket`;

  const socket = new Socket(host, {
    params: {
      userToken: userToken,
      location: path,
    },
  });
  socket.connect();
  const channelRoomId = 'online_users';
  const channel = socket.channel(`room:${channelRoomId}`, {});

  channel
    .join()
    .receive('ok', () => {})
    .receive('error', () => {});
  return channel;
};

export const updatePath = (channel: Channel, path: string) => {
  channel.push('update_path', { path: path });
};
